import { ArrowUpRight, Check, Layers3, Sparkles } from 'lucide-react'
import type { CopyRecipe } from '../types'
import { recipes } from '../lib/rules'

interface RecipeRailProps {
  selected: CopyRecipe['id']
  disabled?: boolean
  onSelect: (recipe: CopyRecipe['id']) => void
}

const icons = { 'all-drive': Layers3, 'media-2y': Sparkles, 'work-docs': ArrowUpRight, custom: Check }

export function RecipeRail({ selected, disabled = false, onSelect }: RecipeRailProps) {
  return (
    <div className="recipe-rail" aria-label="Recetas de copia">
      {recipes.map((recipe, index) => {
        const Icon = icons[recipe.id]
        const active = selected === recipe.id
        return (
          <button className={`recipe-card ${active ? 'is-active' : ''}`} key={recipe.id} onClick={() => onSelect(recipe.id)} type="button" disabled={disabled}>
            <span className="recipe-topline"><span>{String(index + 1).padStart(2, '0')} · {recipe.eyebrow}</span>{active ? <Check size={16} /> : <Icon size={16} />}</span>
            <strong>{recipe.title}</strong>
            <span>{recipe.description}</span>
          </button>
        )
      })}
    </div>
  )
}
